function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSidebarOpenIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "221.512 221.512 56.976 56.976",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 226.512 221.512 L 273.488 221.512 C 276.249 221.512 278.488 223.751 278.488 226.512 L 278.488 273.488 C 278.488 276.249 276.249 278.488 273.488 278.488 L 226.512 278.488 C 223.751 278.488 221.512 276.249 221.512 273.488 L 221.512 226.512 C 221.512 223.751 223.751 221.512 226.512 221.512 Z M 240.967 274.873 L 269.509 274.873 C 272.27 274.873 274.509 272.634 274.509 269.873 L 274.509 230.352 C 274.509 227.591 272.27 225.352 269.509 225.352 L 240.967 225.352 Z M 230.934 250.495 C 228.158 250.495 225.907 252.746 225.907 255.522 C 225.907 258.298 228.158 260.549 230.934 260.549 C 233.71 260.549 235.961 258.298 235.961 255.522 C 235.961 252.746 233.71 250.495 230.934 250.495 Z M 230.934 238.441 C 228.158 238.441 225.907 240.692 225.907 243.468 C 225.907 246.244 228.158 248.495 230.934 248.495 C 233.71 248.495 235.961 246.244 235.961 243.468 C 235.961 240.692 233.71 238.441 230.934 238.441 Z M 230.934 226.387 C 228.158 226.387 225.907 228.638 225.907 231.414 C 225.907 234.19 228.158 236.441 230.934 236.441 C 233.71 236.441 235.961 234.19 235.961 231.414 C 235.961 228.638 233.71 226.387 230.934 226.387 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 136.889 125.1 Q 138.076 122.772 139.263 125.1 L 147.68 141.608 Q 148.867 143.936 146.493 143.936 L 129.659 143.936 Q 127.285 143.936 128.472 141.608 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(0, 1, -1, 0, 390.936157, 111.923973)"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSidebarOpenIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sidebar-open-icon.9d468387a14fc26ed0590dad767d0ade.svg";